import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { FilterIdChip } from 'shared/mui/Filter/FilterChipsToolbar/FilterChips';
import { FilterIdTypes } from 'shared/mui/Filter/hooks/useIdFilters';

type FilterIdChipsProps = {
  omit?: FilterIdTypes[];
  onClick: (type: FilterIdTypes) => void;
};

export const FilterIdChips: React.FC<FilterIdChipsProps> = ({ omit, onClick }) => {
  const translate = useTypedTranslate();

  const chips = [
    { type: FilterIdTypes.Id, label: translate('app.filter.idKubera') },
    { type: FilterIdTypes.Merchant, label: translate('app.filter.idMerchant') },
    { type: FilterIdTypes.Provider, label: translate('app.filter.idProvider') },
    { type: FilterIdTypes.Any, label: translate('app.filter.idAny') },
  ];

  return (
    <>
      {chips
        .filter(({ type }) => !omit?.includes(type))
        .map(({ type, label }) => (
          <FilterIdChip
            key={type}
            label={label}
            limitTags={2}
            name={type}
            onClick={() => onClick(type)}
          />
        ))}
    </>
  );
};
